import React from 'react';
import Image from 'next/image';
import { toast } from 'react-toastify';
import useDevice from '@/hooks/useDevice';
import Typography from '@/components/UI/typography/Typography';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Divider from '@/components/UI/divider/Divider';
import styles from './ShareDrawer.module.scss';
type ShareDrawerProps = {
  handleClose: () => void;
};
const text = `ببین توی "شب" چی پیدا کردم؛ از اون خونه‌هاست که قراره توش خوش بگذره 
بگیریمش بریم؟ 👇🏻`;
const updateUrlParam = value => {
  const url = new URL(value as any);
  const params = new URLSearchParams(url.search);
  if (params.get('from')) {
    params.set('from', 'share');
    url.search = params.toString();
    return url.toString();
  }
  return value;
};
const handleNativeShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: 'سایت شب',
        text,
        url: window.location.href
      });
    } catch (error) {
      console.error('Sharing failed', error);
    }
  }
};
export const getShareOptions = (handleClose: () => void, isMobile: boolean | undefined) => {
  return [{
    src: '/images/icons/copy.png',
    alt: 'copy logo',
    onlyMobile: false,
    text: 'کپی کردن لینک اقامتگاه',
    action: () => {
      if (document.queryCommandSupported('copy')) {
        navigator?.clipboard?.writeText(updateUrlParam(window.location.href?.split('#')[0]).toString()).then(() => {
          toast.success('لینک کپی شد', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
          handleClose();
        }).catch(() => {
          toast.error('خطا در کپی کردن', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        });
      } else {
        toast.error('خطا در کپی کردن', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
    }
  }, {
    src: '/images/icons/whatsapp.png',
    alt: 'whatsapp logo',
    text: 'واتساپ',
    onlyMobile: false,
    action: () => {
      window.open(`whatsapp://send?text=${encodeURIComponent(`${text}\n${updateUrlParam(window.location)}`)}`, '_blank');
      handleClose();
    }
  }, {
    src: '/images/icons/telegram.png',
    alt: 'telegram logo',
    text: 'تلگرام',
    onlyMobile: false,
    action: () => {
      window.open(`https://t.me/share/url?url=${updateUrlParam(window.location)}&text=${text}`, '_blank');
      handleClose();
    }
  }, (window as any)?.navigator?.share && isMobile && {
    src: '/images/icons/more.png',
    alt: 'more',
    text: 'بیشتر',
    onlyMobile: false,
    action: handleNativeShare
  }].filter(Boolean);
};
const ShareDrawer = ({
  handleClose
}: ShareDrawerProps) => {
  const {
    isMobile
  } = useDevice();
  const shareOptions = getShareOptions(handleClose, isMobile);
  return <Box className={styles['share-drawer']} data-sentry-element="Box" data-sentry-component="ShareDrawer" data-sentry-source-file="ShareDrawer.tsx">
      <Box className={styles['share-drawer-header']} data-sentry-element="Box" data-sentry-source-file="ShareDrawer.tsx">
        <Box onClick={handleClose} className={styles['share-drawer-header-close']} data-sentry-element="Box" data-sentry-source-file="ShareDrawer.tsx">
          <Icon name="close" type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="ShareDrawer.tsx" />
        </Box>
        <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="ShareDrawer.tsx">اشتراک گذاری اقامتگاه</Typography>
      </Box>
      <Box className={styles['share-drawer-info']} data-sentry-element="Box" data-sentry-source-file="ShareDrawer.tsx">
        <Typography variant="bodyL" color="neutral_700" data-sentry-element="Typography" data-sentry-source-file="ShareDrawer.tsx">
          این اقامتگاه را با دوستان خود به اشتراک بگذارید
        </Typography>
      </Box>
      <Box className={styles['share-drawer-list']} data-sentry-element="Box" data-sentry-source-file="ShareDrawer.tsx">
        {shareOptions.map((item, index) => !item.onlyMobile && <Box key={`SHARE_OPTION_${index}`} onClick={item.action} className={styles['share-drawer-list-item']}>
                <Image width={24} height={24} src={item.src} alt={item.alt} />
                <Typography variant="bodyL">{item.text}</Typography>
              </Box>)}
      </Box>
      <Divider data-sentry-element="Divider" data-sentry-source-file="ShareDrawer.tsx" />
    </Box>;
};
export default ShareDrawer;